import React from 'react'

import styles from './index.module.css'

const Tags = ({ tags, className }) => {
  const renderTags = () => {
    return tags.map((tag, i) => {
      let url = `/tags/${tag}`
      let separator = tags.length === i + 1 ? '' : ','

      return (
        <li key={tag + i} className={styles.tag}>
          <a className={styles.link} href={url}>
            {tag}
          </a>
          {separator}
        </li>
      )
    })
  }

  return (
    <ul className={styles.tags}>
      <li className={styles.tagsLabel}>Tags</li>
      {renderTags()}
    </ul>
  )
}

export default Tags
